import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Colors, TextStyles, Space } from '../../types';

export const FormError: ComponentStyleConfig = {
  baseStyle: {
    text: {
      '--form-error-color': `colors.${Colors.TEXT_ERROR}`,
      '&': { apply: `textStyles.${TextStyles.UI_COMPACT}` },
      my: Space.XS,
      gap: Space.XS,
      ps: Space['2XS'],
    },
    icon: {
      fontSize: '1.125em',
      boxSize: '1lh',
      color: Colors.ICON_ERROR,
      me: 0,
    },
  },
};
